module.exports = __webpack_public_path__ + "static/media/code_freelance.4a7907b6.png";